import React, { useState } from 'react';

import AccordionTitle from './AccordionTitle';
import AccordionDescription from './AccordionDescription';

interface IProps {
  title: string;
  description: string | JSX.Element;
}
export default function Accordion({ title, description }: IProps): JSX.Element {
  const [accordionIsOpen, setAccordionIsOpen] = useState(false);

  return (
    <div>
      <AccordionTitle
        title={title}
        open={accordionIsOpen}
        toggleAccordion={setAccordionIsOpen}
      />
      <AccordionDescription content={description} open={accordionIsOpen} />
    </div>
  );
}
